import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import notlog from "@/components/notlog/notlog.vue"
import nodate from '@/components/notdate/notdate.vue';
import fundsTransfe from "@/components/fundsTransfe/fundsTransfe.vue";
import topUp from "@/components/topUp/topUp.vue";

import config from '@/common/api/config';

import currencyApi from '@/common/api/currency';
import userApi from '@/common/api/user';
import tradeApi from '@/common/api/trade';

import {mapGetters, mapState} from "vuex";

import { KLineChartPro, DefaultDatafeed } from '@klinecharts/pro'
import '@klinecharts/pro/dist/klinecharts-pro.css'
import { applyKlineProTheme } from '@/common/util/klineTheme';

let socket = false;
let socketInterval = false;

let amax;
let bmax;

let slider = false;
//k线图相关变量
let klineCharts;
let _ticker;
let upset = false;
let isComponentDestroyed = false;
let chartSymbolFrame = false;
let chartSymbolDebounce = false;
let chartSymbolRetry = false;
let chartSymbolUpdateToken = 0;
let klineChartSession = 0;
let klineSubscriptionToken = 0;
let klineHistoryRequestCount = 0;
let pairSwitchTimer = false;

let firstPrice;
let last;

const time = {
    '1s':0,
    '1m':1,
    '5m':5,
    '15m':15,
    '30m':30,
    '1H':60,
    '4H':240,
    '12H':720,
    '1D':1440,
    '1W':10080
}

function invalidateKlineSession() {
    klineChartSession += 1;
    klineSubscriptionToken += 1;
    last = undefined;

    if (upset !== false) {
        clearInterval(upset);
        upset = false;
    }
}

export default {
    components: {Footer, PageNav, notlog,nodate,fundsTransfe,topUp},
    data() {
        return {
            coinName: "BTC",
            coinType: "USDT",
            showAll: false,
            chartType: 0,
            timeActive: 0,
            timeEdit: false,
            tableActive: 0,
            aboutCoin: false,
            decimal: "0.000001",
            listType: 0,
            timer: "",
            btnActive: 0,
            tabActive:1,
            modeIndex: 0,
            subtabActive: 0,
            marks: {
                0: '0%',
                25: '25%',
                50: '50%',
                75: '75%',
                100: '100%'
            },
            currency: [], //所有现货交易对
            current: false, //当前币种数据
            currencyInfo: {}, //币种详情数据

            asks: [],
            bids: [],
            lastPrice: 0,
            tradeList: [],
            orderList:[],
            history:[],

            balance: {},
            amount: "",//委托数量
            rate: 0,//百分比
            pamount: '',//成交额
            price : '',//委托价格

            loading:false,
            pairSwitching:false,
            transfeVisable:false,
            topVisable:false,
            orderInfoPopup: false, //订单详情
            pindex: false //操作订单的索引
        }
    },
    computed: {
        ...mapGetters(['isLogin', 'symbol', 'symbol_rate', 'isLogin', 'userId']),
        ...mapState(['userinfo', 'userTheme'])
    },
    mounted() {
        // 重置组件销毁标志
        isComponentDestroyed = false;
        this.getTradeCurrencyList();
        
        // 处理从排行榜页面传递的币种参数
        this.handleRouteParams();
        
        // 🎨 为顶部热门币种添加调试功能 - 安全延迟执行
        setTimeout(() => {
            this.$nextTick(() => {
                console.log('💰 现货交易页面已加载 - 截图样式版本')
                console.log('🎯 顶部热门币种现在完全匹配用户截图样式：')
                console.log('  📈 上涨: #00ff88 绿色')
                console.log('  📉 下跌: #ff4444 红色')
                console.log('  📊 无变化: 半透明白色')
                console.log('  🎨 新特性: 透明背景、融入深色主题、简洁布局')
                
                // 创建测试函数 - 增加布局检查
                window.testSpotDisplay = () => {
                    try {
                        const hotCoin = document.querySelector('.spot .hotCoin')
                        const items = document.querySelectorAll('.spot .hotCoin .item')
                        
                        if (!items || items.length === 0) {
                            console.warn('⚠️ 未找到现货页面热门币种元素')
                            return { error: '未找到元素' }
                        }
                        
                        let stats = { 
                            green: 0, red: 0, gray: 0, total: items.length,
                            containerHeight: hotCoin ? hotCoin.offsetHeight : 0,
                            itemHeights: []
                        }
                        
                        items.forEach((item, index) => {
                            if (item && item.querySelectorAll) {
                                stats.itemHeights.push(item.offsetHeight)
                                const spans = item.querySelectorAll('span')
                                spans.forEach(span => {
                                    if (span && span.classList) {
                                        if (span.classList.contains('color-green')) stats.green++
                                        else if (span.classList.contains('color-red')) stats.red++
                                        else if (span.classList.contains('color-gray')) stats.gray++
                                    }
                                })
                            }
                        })
                        
                        console.log('💰 现货页面热门币种显示统计:', stats)
                        console.log('✅ 颜色统计 - 绿色:', stats.green, '红色:', stats.red, '灰色:', stats.gray)
                        console.log('📐 布局统计 - 容器高度:', stats.containerHeight + 'px', '元素高度:', stats.itemHeights)
                        console.log('🎯 如果容器高度≥36px且元素高度一致，说明布局优化成功')
                        
                        // 添加K线图布局检查
                        const klineBox = document.querySelector('.klineBox');
                        const orderList = document.querySelector('.orderList');
                        const leftContainer = document.querySelector('.container .left');
                        const containerBottom = document.querySelector('.containerBottom');
                        const rightComponent = document.querySelector('.right');
                        
                        if (klineBox && orderList && leftContainer) {
                            const klineStyle = window.getComputedStyle(klineBox);
                            const orderStyle = window.getComputedStyle(orderList);
                            const leftStyle = window.getComputedStyle(leftContainer);
                            
                            console.log('📊 K线图布局状态:', {
                                klineWidth: klineStyle.width,
                                klineMarginRight: klineStyle.marginRight,
                                orderWidth: orderStyle.width,
                                leftContainerWidth: leftStyle.width
                            });
                            
                            console.log('✅ K线图组件已向右扩展80px，更靠近订单表');
                        }
                        
                        // 检查下方组件布局
                        if (containerBottom) {
                            const bottomStyle = window.getComputedStyle(containerBottom);
                            console.log('📋 下方组件布局状态:', {
                                containerBottomWidth: bottomStyle.width,
                                expectedWidth: '1488px (K线图1080px + 右边距8px + 订单表400px)'
                            });
                            console.log('✅ 下方组件宽度已调整为与上方组件保持平衡');
                        }
                        
                        // 检查右侧组件布局
                        if (rightComponent) {
                            const rightStyle = window.getComputedStyle(rightComponent);
                            console.log('🔄 右侧组件布局状态:', {
                                rightComponentWidth: rightStyle.width,
                                orderListWidth: orderList ? window.getComputedStyle(orderList).width : 'N/A'
                            });
                            console.log('✅ 右侧组件宽度已调整为与订单表保持一致');
                        }
                        
                        return stats
                    } catch (error) {
                        console.error('❌ 测试现货显示时出错:', error)
                        return { error: error.message }
                    }
                }
                
                console.log('💡 提示: 可以在控制台执行 window.testSpotDisplay() 来测试显示效果和布局')
            })
        }, 1000)
    },
    watch: {
        isLogin(v) {
            if (v && this.current) {
                this.getCurrencyBalance();
                this.getOrderList();
            }
        },
        tabActive(v){
            if(parseInt(v) === 2){
                if(this.price === ''){
                    this.price = this.current['new_price'];
                }
            }
        },
        btnActive(v){
            this.amount = '';
            this.pamount = '';
            this.rate = 0;
        },
        userTheme(newTheme, oldTheme) {
            if (newTheme !== oldTheme && klineCharts) {
                this.$nextTick(() => {
                    applyKlineProTheme(
                        klineCharts,
                        newTheme,
                        document.getElementById('chartBox')
                    );
                });
            }
        },
        '$i18n.locale'(newLocale, oldLocale) {
            // 语言变化时重新初始化K线图
            if (newLocale !== oldLocale && klineCharts) {
                this.$nextTick(() => {
                    this.refreshKlineChart();
                });
            }
            // 语言切换时强制重新渲染
            this.$forceUpdate();
        }
    },
    methods: {
        // 将Vue i18n语言代码映射到KLineChartPro语言代码
        // KLineChartPro默认只支持 en-US 和 zh-CN，其他语言需要注册
        getKlineLocale() {
            const vueLocale = this.$i18n?.locale || 'en-US';
            // KLineChartPro实际支持的语言代码（默认只支持这两种）
            // 其他语言会回退到 en-US
            const localeMap = {
                'en-US': 'en-US',
                'zh_CN': 'zh-CN',
                'zh_Hant': 'zh-CN', // 繁体中文也使用简体中文
                'ru': 'en-US', // 俄语回退到英文
                'th': 'en-US', // 泰语回退到英文
                'ja': 'en-US', // 日语回退到英文
                'ko': 'en-US', // 韩语回退到英文
                'au': 'en-US', // 澳大利亚英语使用英文
                'gm': 'en-US'  // 德语回退到英文
            };
            const klineLocale = localeMap[vueLocale] || 'en-US';
            console.log('🌐 K线图语言映射:', { vueLocale, klineLocale });
            return klineLocale;
        },
        async createCharts(){
            if (!this.current || !this.current['id']) {
                return false;
            }

            const chartContainer = document.getElementById('chartBox');
            if (!chartContainer) {
                return false;
            }

            // 获取K线图语言代码
            const klineLocale = this.getKlineLocale();
            
            // KLineChartPro已内置zh-CN和en-US语言包，无需手动加载
            // 只需在创建图表时设置locale参数即可
            console.log('🔧 K线图语言设置:', klineLocale);
            
            let _this = this;
            class CustomDatafeed {
                searchSymbols(search) {
                }
                async getHistoryKLineData(symbol, period, from, to) {
                    const chartCurrency = _this.getChartCurrency(symbol);
                    const requestToken = klineChartSession;
                    const isActiveSession = () => {
                        const activeSymbol = klineCharts?.getSymbol?.();
                        const activePeriod = klineCharts?.getPeriod?.();

                        return !isComponentDestroyed
                            && requestToken === klineChartSession
                            && (!activeSymbol || activeSymbol.ticker === chartCurrency.ticker)
                            && (!activePeriod || activePeriod.text === period.text);
                    };

                    if (!chartCurrency.id || !isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
                        return [];
                    }

                    klineHistoryRequestCount += 1;
                    try {
                        let res = await currencyApi.contractLine({
                            interval: period.text,
                            currency_id: chartCurrency.id,
                            limit:1000
                        });

                        if (!isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
                            return [];
                        }

                        _this.$util.setCache('local-period',JSON.stringify(period));
                        let type = 'candle_solid';
                        if(period.text === '1s'){
                            type = 'area';
                        }
                        klineCharts.setStyles({
                            candle:{
                                type:type
                            }
                        });
                        let data = res.data.map((item)=>{
                            return {
                                timestamp:item['time'],
                                open: item['open'],
                                high: item['high'],
                                low: item['low'],
                                close: item['close'],
                                volume: item['vol'],
                                turnover:item['amount'],
                            }
                        });
                        const latest = data[data.length - 1];
                        if (!last || (latest && latest.timestamp >= last.timestamp)) {
                            last = latest;
                        }
                        return data;
                    } finally {
                        klineHistoryRequestCount = Math.max(0, klineHistoryRequestCount - 1);
                    }
                }
                subscribe(symbol, period, callback) {
                    const subscriptionToken = ++klineSubscriptionToken;
                    const chartCurrency = _this.getChartCurrency(symbol);
                    const session = klineChartSession;

                    if (upset !== false) {
                        clearInterval(upset);
                    }

                    upset = setInterval(()=>{
                        const activeSymbol = klineCharts?.getSymbol?.();
                        const activePeriod = klineCharts?.getPeriod?.();
                        if (isComponentDestroyed
                            || session !== klineChartSession
                            || subscriptionToken !== klineSubscriptionToken
                            || symbol?.ticker !== chartCurrency.ticker
                            || (activeSymbol && activeSymbol.ticker !== chartCurrency.ticker)
                            || (activePeriod && activePeriod.text !== period.text)) {
                            return;
                        }

                        if (!_ticker || _ticker['c'] === undefined) {
                            return;
                        }
                        
                        if(period.text === '1s'){
                            firstPrice = parseFloat(_ticker['c']);
                            callback({
                                timestamp:_ticker['E'],
                                open:firstPrice,
                                close:firstPrice,
                                high:firstPrice,
                                low:firstPrice,
                                volume:parseInt(_ticker['Q'] || 0),
                                turnover:parseInt(_ticker['Q'] || 0),
                            });
                        }else{
                            let minint = time[period.text] * 60 * 1000;
                            firstPrice = parseFloat(_ticker['c']);
                            let data;
                            if (!last || !last.timestamp || parseInt(_ticker['E']) - last['timestamp'] > minint){
                                data = {
                                    timestamp:parseInt(_ticker['E']),
                                    open:firstPrice,
                                    close:firstPrice,
                                    high:firstPrice,
                                    low:firstPrice,
                                    volume:parseInt(_ticker['Q'] || 0),
                                    turnover:parseInt(_ticker['Q'] || 0),
                                };

                            }else{
                                data = {
                                    timestamp:last['timestamp'],
                                    open:last['open'],
                                    close:firstPrice,
                                    high:last['high'] < firstPrice ? firstPrice : last['high'],
                                    low:last['low'] > firstPrice ? firstPrice : last['low'],
                                    volume:last['volume'] + parseInt(_ticker['Q'] || 0),
                                    turnover:last['turnover'] + parseInt(_ticker['Q'] || 0),
                                };
                            }
                            last = data;
                            callback(data);
                        }
                    },500);
                }
                unsubscribe(symbol, period) {
                    klineSubscriptionToken += 1;
                    if (upset !== false) {
                        clearInterval(upset);
                        upset = false;
                    }
                }
            }
            // 现货页面强制使用1分钟作为默认周期，忽略缓存
            let localPeriod = {
                multiplier: 1, timespan: 'minute', text: '1m'
            };
            klineCharts = new KLineChartPro({
                container: chartContainer,
                watermark:"",
                theme:this.userTheme,
                locale: klineLocale, // 使用当前语言设置（必须在创建时设置，后续无法更改）
                timezone:this.$util.getCache('time_zone'),
                // 初始化标的信息
                symbol: {
                    ticker: this.current['symbol'] + 'USDT',
                    pricePrecision:this.current['decimals'],
                    logo:this.current['icon'],
                    type:"ADRC"
                },
                // 初始化周期
                period: localPeriod,
                periods:[
                    {multiplier:0,timespan:'second',text:'1s'},
                    {multiplier:1,timespan:'minute',text:'1m'},
                    {multiplier:5,timespan:'minute',text:'5m'},
                    {multiplier:15,timespan:'minute',text:'15m'},
                    {multiplier:30,timespan:'minute',text:'30m'},
                    {multiplier:60,timespan:'minute',text:'1H'},
                    {multiplier:240,timespan:'minute',text:'4H'},
                    {multiplier:720,timespan:'minute',text:'12H'},
                    {multiplier:1440,timespan:'minute',text:'1D'},
                    {multiplier:10080,timespan:'minute',text:'1W'}
                ],
                subIndicators: [],
                datafeed: new CustomDatafeed()
            })

            // KLineChartPro支持setLocale方法，在创建后也可以设置语言
            // 但为了确保设置弹窗也使用正确语言，我们在创建后再次调用setLocale
            if (klineCharts && klineCharts.setLocale) {
                try {
                    klineCharts.setLocale(klineLocale);
                    console.log('✅ 现货K线图语言设置成功:', klineLocale);
                } catch (error) {
                    console.warn('⚠️ 设置K线图语言失败:', error);
                }
            }
            
            console.log('✅ 现货K线图表创建成功，语言:', klineLocale);
        },
        reloadCredit(){
            this.getCurrencyBalance();
        },
        orderChange(e){
            if(parseInt(e) === 2){
                this.getHistoryList();
            }
        },
        historyOrderScroll(e){
            console.log(e);
        },
        getOrderList(){
            if(this.isLogin && this.current){
                tradeApi.tradeOrderList(this.current['id']).then(res=>{
                    // 检查组件是否已销毁
                    if (isComponentDestroyed) {
                        return;
                    }
                    this.orderList = res.data;
                });
            }
        },
        getHistoryList(){
            tradeApi.orderHistory(this.current['id'],1).then(res=>{
                // 检查组件是否已销毁
                if (isComponentDestroyed) {
                    return;
                }
                this.history = res.data.list;
            });
        },
        cancelOrder(orderId){
            tradeApi.orderCancel(orderId).then(res=>{
                // 检查组件是否已销毁
                if (isComponentDestroyed) {
                    return;
                }
                
                if(res.code === 200){
                    this.$notification.success(this.$t('spot.order_cancelled'));
                    this.getOrderList();
                }
            })
        },
        submitOrder(){
            if(this.amount === '' || this.pamount === '' || this.amount <= 0 || this.pamount <= 0){
                return;
            }
            if(
                (this.btnActive === 0 && parseFloat(this.pamount) > parseFloat(this.balance['legal_balance'])) ||
                (this.btnActive === 1) && parseFloat(this.amount) > parseFloat(this.balance['trade_balance'])
            ){
                this.$notification.info(this.$t('spot.insufficient_balance'));
                this.loading = false;
                return;
            }
            this.loading = true;
            const form = {
                cmd_id: 1,
                currency_id: this.current['id'],
                order_type: this.tabActive,
                direction: this.btnActive === 0 ? 1 : 2,
                trade_type: 1,
                price: this.tabActive === 1 ? parseFloat(this.current['new_price']) : parseFloat(this.price),
                amount: this.btnActive === 0 ? parseFloat(this.pamount) : parseFloat(this.amount)
            };
            tradeApi.tradeSubmit(form).then(res=>{
                // 检查组件是否已销毁
                if (isComponentDestroyed) {
                    return;
                }
                
                this.loading = false;
                this.rate = 0;
                this.amount = '';
                this.pamount = '';
                this.price = '';
                if(res.code === 200){
                    this.$notification.info(parseInt(this.tabActive) === 1 ? this.$t('spot.filled') : this.$t('spot.submitted'));
                    // 检查组件是否已销毁和refs是否存在
                if (!isComponentDestroyed && this.$refs.audioPlayer) {
                    this.$refs.audioPlayer.play();
                }
                    this.getCurrencyBalance();
                    this.getOrderList();
                }else{
                    this.$notification.info(res.message);
                }
            }).catch((e)=>{
                this.loading = false;
                this.$notification.info(e);
            })
        },
        /**
         * 限价委托单输入价格
         */
        inputPrice(e){
            this.price = e;
        },
        inputAmount(e){
            if(e > 0){
                this.amount = e;
                let price = this.tabActive === 1 ? parseFloat(this.current['new_price']) : (this.price !== '' ? this.price : 0);
                this.pamount = parseFloat(parseFloat(this.amount) * price).toFixed(2);
                if(this.btnActive === 0){
                    let avaAmount = parseFloat(this.balance['legal_balance']) / price;
                    this.rate = this.amount / avaAmount * 100 > 100 ? 100 : this.amount / avaAmount * 100;
                }else{
                    let avaAmount = parseFloat(this.balance['trade_balance']);
                    this.rate = this.amount / avaAmount * 100 > 100 ? 100 : this.amount / avaAmount * 100;
                }
                if(this.amount <= 0){
                    this.amount = '';
                    this.pamount = '';
                    this.rate = 0;
                }
            }
        },
        inputPamoun(e){
            this.pamount = e;
            let price = this.tabActive === 1 ? parseFloat(this.current['new_price']) : (this.price !== '' ? this.price : 0);
            if(this.btnActive === 0){
                this.amount = parseFloat(this.pamount / price).toFixed(this.current['trade_decimals']);
                let avaAmount = parseFloat(this.balance['legal_balance']) / price;
                this.rate = this.amount / avaAmount * 100 > 100 ? 100 :this.amount / avaAmount * 100;
            }else{
                this.amount = parseFloat(this.pamount / price).toFixed(this.current['trade_decimals']);
                let avaAmount = parseFloat(this.balance['trade_balance']);
                this.rate = this.amount / avaAmount * 100 > 100 ? 100 :this.amount / avaAmount * 100;
            }
            if(this.amount <= 0){
                this.amount = '';
                this.pamount = '';
                this.rate = 0;
            }
        },
        sliderChange(e) {
            slider = true;
            this.rate = e;
            let price = this.tabActive === 1 ? parseFloat(this.current['new_price']) : (this.price !== '' ? this.price : 0);
            if(this.btnActive === 0){
                this.amount = parseFloat(parseFloat(this.balance['legal_balance']) / price * (e / 100)).toFixed(this.current['trade_decimals']);
                this.pamount = parseFloat(parseFloat(this.amount) * price).toFixed(2);
            }else{
                this.amount = parseFloat(parseFloat(this.balance['trade_balance']) * (e / 100)).toFixed(this.current['trade_decimals']);
                this.pamount = parseFloat(parseFloat(this.amount) * price).toFixed(2);
            }
            if(this.amount <= 0 || price === 0){
                this.amount = '';
                this.pamount = '';
                this.rate = 0;
            }
            slider = false;
        },
        changeTab(e){
            this.tabActive = parseInt(e);
        },
        connectSocket() {
            // 检查组件是否已销毁
            if (isComponentDestroyed) {
                return;
            }
            
            if (!socket) {
                const deviceId = this.$util.getCache('deviceId');
                const url = config['BASE_WSS'] + '/?token=' + deviceId + '$trade' + '&sub=trade';
                socket = new WebSocket(url);
                socket.onopen = () => {
                    setTimeout(() => {
                        socketInterval = setInterval(() => {
                            // 检查socket是否有效和组件是否已销毁
                            if (!socket || !socket.send || isComponentDestroyed) {
                                return;
                            }
                            socket.send(JSON.stringify({
                                event: 'updateUserId',
                                uid: this.userId
                            }));
                        }, 5000);
                    }, 1500);
                    this.subscribe();
                    socket.onmessage = (data) => {
                        this.onMessage(JSON.parse(data.data));
                    }
                }
            }

        },
        onMessage(data) {
            // 检查组件是否已销毁，避免在销毁后处理消息
            if (isComponentDestroyed) {
                return;
            }
            
            if (data.type === 102) {
                const date = new Date(data.data.data.E);
                let trades = this.tradeList;
                if (trades.length > 50) {
                    trades = trades.slice(1);
                }
                trades.push({
                    time: date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds(),
                    price: data.data.data.p,
                    vol: data.data.data.q
                });
                this.tradeList = trades;
            }
            if (data.type === 100) {
                let ticker = this.$util.getCurrentTicker(this.current['id'], data.data.data);
                
                // 检查组件是否已销毁，避免在销毁后更新DOM
                if (isComponentDestroyed) {
                    return;
                }
                
                // 添加ticker的null检查，避免读取undefined的属性
                if (ticker && ticker['c'] !== undefined) {
                    _ticker = ticker;
                    this.lastPrice = this.current['new_price'];
                    let current = this.current;
                    current['new_price'] = ticker['c'];
                    current['change_rate'] = ticker['P'];
                    current['high_price'] = ticker['h'];
                    current['low_price'] = ticker['l'];
                    current['quantity'] = ticker['v'];
                    current['quota'] = ticker['q']
                    this.current = current;
                } else {
                    console.warn('⚠️ Ticker数据无效:', { 
                        ticker, 
                        currencyId: this.current['id'], 
                        rawData: data.data.data 
                    });
                }
            }
            if (data.type === 101) {
                //深度数据
                amax = 0;
                bmax = 0;
                let asks = data.data.data.asks;
                let bids = data.data.data.bids;
                asks.sort((a, b) => {
                    return a[1] - b[1];
                });
                asks.map((v, i) => {
                    if (amax < parseFloat(v[1])) {
                        amax = v[1];
                    }
                });

                for (let i = 0; i < asks.length; i++) {
                    asks[i][3] = parseFloat(asks[i][1] / amax).toFixed(2);
                }
                asks.reverse();
                bids.map((v, i) => {
                    if (bmax < parseFloat(v[1])) {
                        bmax = v[1];
                    }
                });
                bids.reverse();
                for (let i = 0; i < bids.length; i++) {
                    bids[i][3] = parseFloat(bids[i][1] / bmax).toFixed(2);
                }
                this.asks = asks;
                this.bids = bids;
            }
        },
        subscribe() {
            // 检查socket是否有效和组件是否已销毁
            if (!socket || !socket.send || isComponentDestroyed) {
                console.warn('⚠️ Socket无效或组件已销毁，跳过订阅');
                return;
            }
            
            socket.send(JSON.stringify({
                event: "trade_depth_subscribe",
                cm_id: 1,
                currency_id: this.current['id']
            }));
        },
        getCurrencyBalance() {
            if (this.isLogin) {
                userApi.getCurrencyBalance(this.current['id']).then(res => {
                    // 检查组件是否已销毁
                    if (isComponentDestroyed) {
                        return;
                    }
                    this.balance = res.data;
                });
            }
        },
        // 处理路由参数，支持从排行榜页面跳转
        handleRouteParams() {
            const { symbol, currency_id, currency_name } = this.$route.query;
            
            if (symbol || currency_id) {
                console.log('🎯 检测到路由参数:', { symbol, currency_id, currency_name });
                
                // 延迟执行，确保币种列表已加载
                setTimeout(() => {
                    this.selectCurrencyFromParams(symbol, currency_id);
                }, 1000);
            }
        },
        
        // 根据参数选择币种
        selectCurrencyFromParams(symbol, currency_id) {
            if (!this.currency || !this.currency[0] || !this.currency[0].currency) {
                console.warn('⚠️ 币种列表未加载完成，无法选择指定币种');
                return;
            }
            
            const currencyList = this.currency[0].currency;
            let targetCurrency = null;
            
            // 优先通过currency_id查找
            if (currency_id) {
                targetCurrency = currencyList.find(item => item.id == currency_id);
            }
            
            // 如果通过ID没找到，尝试通过symbol查找
            if (!targetCurrency && symbol) {
                targetCurrency = currencyList.find(item => 
                    item.symbol && item.symbol.toLowerCase() === symbol.toLowerCase()
                );
            }
            
            if (targetCurrency) {
                console.log('✅ 找到目标币种:', targetCurrency.symbol);
                this.setCurrentCurrency(targetCurrency);
                
                // 清除URL参数，避免刷新页面时重复处理
                this.$router.replace({ 
                    path: '/spot', 
                    query: {} 
                });
            } else {
                console.warn('⚠️ 未找到指定的币种:', { symbol, currency_id });
            }
        },
        
        getTradeCurrencyList() {
            currencyApi.tradeCurrencyList().then(res => {
                // 检查组件是否已销毁
                if (isComponentDestroyed) {
                    return;
                }
                
                this.currency = res.data;
                this.getCurrentCurrency();
                this.connectSocket();
                this.getOrderList();
            });
        },
        setCurrentCurrency(item) {
            if (isComponentDestroyed || !item?.id || this.pairSwitching || this.current?.id === item.id) {
                return;
            }

            this.pairSwitching = true;
            invalidateKlineSession();
            _ticker = false;
            chartSymbolUpdateToken += 1;
            if (chartSymbolFrame) {
                cancelAnimationFrame(chartSymbolFrame);
                chartSymbolFrame = false;
            }
            if (chartSymbolDebounce) {
                clearTimeout(chartSymbolDebounce);
                chartSymbolDebounce = false;
            }
            if (chartSymbolRetry) {
                clearTimeout(chartSymbolRetry);
                chartSymbolRetry = false;
            }

            pairSwitchTimer = setTimeout(() => {
                pairSwitchTimer = false;
                if (isComponentDestroyed) {
                    return;
                }

                this.current = item;
                this.getCurrencyInfo(this.current['id']);
                this.subscribe();
                this.getCurrencyBalance();
                this.getOrderList();
                this.tradeList = [];
                this.$util.setCache('trade-current', JSON.stringify(item));
                this.scheduleChartSymbolUpdate(item);
                this.pairSwitching = false;
            }, 2000);
        },
        getChartCurrency(symbol) {
            const ticker = symbol?.ticker || '';
            const currency = this.currency
                ?.flatMap((group) => group.currency || [])
                .find((item) => item.symbol + 'USDT' === ticker);

            return {
                id: currency?.id || (this.current?.symbol + 'USDT' === ticker ? this.current.id : false),
                ticker
            };
        },
        scheduleChartSymbolUpdate(item) {
            const updateToken = ++chartSymbolUpdateToken;
            if (chartSymbolFrame) {
                cancelAnimationFrame(chartSymbolFrame);
                chartSymbolFrame = false;
            }
            if (chartSymbolDebounce) {
                clearTimeout(chartSymbolDebounce);
                chartSymbolDebounce = false;
            }
            if (chartSymbolRetry) {
                clearTimeout(chartSymbolRetry);
                chartSymbolRetry = false;
            }

            // Coalesce rapid clicks, then switch only after the library has completed
            // its previous async load. Rebuilding the chart here causes ResizeObserver
            // loops inside KLineChartPro under quick successive pair changes.
            chartSymbolDebounce = setTimeout(() => {
                chartSymbolDebounce = false;
                this.applyChartSymbol(item, updateToken);
            }, 120);
        },
        applyChartSymbol(item, updateToken) {
            if (isComponentDestroyed || updateToken !== chartSymbolUpdateToken || !klineCharts) {
                return;
            }

            if (klineHistoryRequestCount > 0) {
                chartSymbolRetry = setTimeout(() => {
                    chartSymbolRetry = false;
                    this.applyChartSymbol(item, updateToken);
                }, 50);
                return;
            }

            const chart = klineCharts;
            const ticker = item['symbol'] + 'USDT';
            if (chart.getSymbol?.()?.ticker === ticker) {
                return;
            }
            this.$nextTick(() => {
                chartSymbolFrame = requestAnimationFrame(() => {
                    chartSymbolFrame = false;

                    if (isComponentDestroyed || updateToken !== chartSymbolUpdateToken || klineCharts !== chart) {
                        return;
                    }

                    chart.setSymbol({
                        ticker,
                        pricePrecision: item['decimals'],
                        logo: item['icon'],
                        type: ""
                    });
                });
            });
        },
        getCurrentCurrency() {
            const currency = this.$util.getCache('trade-current', '');
            if (currency === '') {
                this.current = this.currency[0]['currency'][0];
                this.$util.setCache('trade-current', JSON.stringify(this.current));
            } else {
                this.current = JSON.parse(currency);
            }
            this.createCharts();
            this.getCurrencyInfo(this.current['id']);
            this.getCurrencyBalance();
        },
        getCurrencyInfo(currency_id) {
            currencyApi.getCurrencyInfo(currency_id, 1).then(res => {
                // 检查组件是否已销毁
                if (isComponentDestroyed) {
                    return;
                }
                
                this.currencyInfo = res.data;
                if (this.currencyInfo.currency_info != null) {
                    this.currencyInfo.currency_info = JSON.parse(this.currencyInfo.currency_info);
                    console.log(this.currencyInfo.currency_info);
                }
            });
        },
        tableToggle(item, index) {
            this.tableActive = index;
            this.coinName = item.name;
            this.coinType = item.type;
        },
        // aboutCoinShow() {
        //     this.aboutCoin = true;
        // },
        numSelect(e) {
            this.decimal = e;
        },
        toDetail() {
            this.$router.push("/HomeView/futures/futuresData")
        },
        refreshKlineChart() {
            if (klineCharts) {
                try {
                    invalidateKlineSession();
                    // 销毁旧的K线图实例
                    klineCharts.destroy();
                    klineCharts = null;
                    
                    // 重新创建K线图
                    this.createCharts();
                } catch (error) {
                    console.error('❌ 刷新K线图失败:', error);
                }
            }
        }
    },
    beforeUnmount() {
        // 设置组件销毁标志，防止异步操作继续执行
        isComponentDestroyed = true;
        invalidateKlineSession();
        chartSymbolUpdateToken += 1;
        if (chartSymbolFrame) {
            cancelAnimationFrame(chartSymbolFrame);
            chartSymbolFrame = false;
        }
        if (chartSymbolDebounce) {
            clearTimeout(chartSymbolDebounce);
            chartSymbolDebounce = false;
        }
        if (chartSymbolRetry) {
            clearTimeout(chartSymbolRetry);
            chartSymbolRetry = false;
        }
        if (pairSwitchTimer) {
            clearTimeout(pairSwitchTimer);
            pairSwitchTimer = false;
        }
        this.pairSwitching = false;
        
        clearInterval(this.timer);
        this.timer = null;
        
        // 安全关闭socket连接
        if (socket && socket.close && typeof socket.close === 'function') {
            socket.close();
        }
        
        if (socketInterval) {
            clearInterval(socketInterval);
        }
        if (klineCharts) {
            try {
                klineCharts.destroy();
            } catch (error) {
                console.warn('⚠️ 销毁K线图失败:', error);
            }
            klineCharts = false;
        }
        socket = false;
    }
}
